module.exports = __webpack_public_path__ + "static/media/privatleistung02.515ee22f.jpg";